import { Button } from '@/shared/ui';
import FirstMedicationPic from '@/assets/images/medbox/first-medication.svg';

interface IProps {
    handleAddMore: () => void;
}

export const FirstMedicationPopup = ({ handleAddMore }: IProps) => {
    return (
        <div className="flex flex-col items-center" data-testid="first-medication-popup">
            <img src={FirstMedicationPic} className="w-[178px] lg:w-[200px]" />

            <div className="mb-3 flex flex-col items-center text-center font-agrandir text-2xl lg:text-4xl xl:leading-[2.75rem]">
                <span data-testid="first-medication-title">Hooray!</span>
                <span data-testid="first-medication-content-text">You've successfully added your first medication!</span>
            </div>
            <span className="text-center text-lg font-bold" data-testid="first-medication-bottom-text">Keep up the great work!</span>

            <Button
                variant="contained"
                className="prescriptions__popup_continue_btn mt-6 w-full"
                showEndIcon
                onClick={handleAddMore}
                testId="button-first-medication-add-more"
                fontClassName='font-bold'
            >
                Add More
            </Button>
        </div>
    );
};
